import React from "react";
import { Button, Stack } from "@mui/material";
import styled from "styled-components";
import { Link as RouteLink } from "react-router-dom";
import spaceshipDb from "src/assets/icons/spaceship-db";
import Icon from "src/components/icon";

const H2 = styled.h2`
    font-size: 22px;
    font-weight: 500;
    margin: 0;
    color: ${({ theme }) => theme.palette.error.main};
`;

const Span = styled.span`
    font-size: 16px;
    font-weight: 300;
    opacity: 0.35;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const BorderedStack = styled(Stack)`
    border: ${({ theme }) => `3px dashed ${theme.palette.background.paper}`};
    border-radius: 14px;
    width: 100%;
`;

const BodyText = styled.p`
    font-size: 14px;
    font-weight: 300;
    margin: 0;
`;

const IntegratedNoResponse = () => {
    return (
        <BorderedStack
            spacing={2}
            direction="column"
            justifyContent="center"
            alignItems="center"
            p={10}
            m={3}
        >
            <Icon svg={spaceshipDb} width="100px" height="auto" opacity="0.3" />
            <Stack alignItems="center">
                <Icon svg={spaceshipDb} width="100%" height="50%" />
                <H2>Internal server error</H2>
                <Span style={{ marginBottom: "3rem" }}>No data returned for your account</Span>
                <BodyText>Feel free to contact us!</BodyText>
            </Stack>
            <Button
                variant="contained"
                component={RouteLink}
                to="/integrations"
                data-testid="dashboard-link"
            >
                Contact Support
            </Button>
        </BorderedStack>
    );
};

export default IntegratedNoResponse;
